import { ButtonBase } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import Image from 'next/image';
import { useRouter } from 'next/router';
import GridContainer2 from '@/components/Layout/GridContainer2/GridContainer2';
import { SpacingContainer } from '@/components/SpacingContainer/SpacingContainer';
import type { ProductGridAdapted } from '@/contentful/api/sunrunShopTypes';
import useGlobalStyles from '@/styles/global.styles';
import { formatUSD } from '@/utils/currency';
import shopifyImageLoader from '@/utils/imageLoaders/shopify';
import useStyles from './ProductCatalogList.styles';

type ProductCatalogListProps = {
  content: ProductGridAdapted;
};

const ProductCatalogList = (props: ProductCatalogListProps) => {
  const {
    content: { fields },
  } = props;
  const gridValues = fields;
  const { classes, cx } = useStyles();
  const router = useRouter();
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });
  return (
    <SpacingContainer
      isFeatured
      className={classes.spacingContainer}
      data-testid='productCatalogList'
    >
      <GridContainer2 fixed>
        <Grid2 xs={12}>
          {gridValues.heading && (
            <h2 className={cx(globalClasses.h2, classes.heading)}>
              {gridValues.heading}
            </h2>
          )}
        </Grid2>
        <Grid2 xs={12}>
          {gridValues.subhead && (
            <h2 className={globalClasses.body2}>{gridValues.subhead}</h2>
          )}
        </Grid2>
        {gridValues.products.map((product, idx: number) => {
          if (!product) {
            return null;
          }
          const { title, featuredImage, minPrice, sunrunProductPageUrl } =
            product || {};
          // Extract the first variant for price
          const price = minPrice
            ? formatUSD(minPrice, 2, 2)
            : 'Price not available';

          return (
            <Grid2
              xs={6}
              sm={6}
              md={4}
              key={`${title}-${price}`}
              className={classes.cardWrapper}
              data-testid='product-card'
            >
              <ButtonBase
                onClick={() => router.push(sunrunProductPageUrl)}
                data-testid={`${title}-${idx}`}
                className={classes.productCard}
                disableRipple
              >
                <div className={classes.productImageWrapper}>
                  <Image
                    src={featuredImage.url}
                    alt={featuredImage.altText || title}
                    className={classes.productImage}
                    width={500}
                    height={500}
                    loader={shopifyImageLoader}
                  />
                </div>
                <div className={classes.textContainer}>
                  <h3 className={cx(globalClasses.body2, classes.productTitle)}>
                    {title}
                  </h3>
                  <p className={cx(globalClasses.body2, classes.productPrice)}>
                    {price}
                  </p>
                </div>
              </ButtonBase>
            </Grid2>
          );
        })}
      </GridContainer2>
    </SpacingContainer>
  );
};

export default ProductCatalogList;
